module.exports = __webpack_public_path__ + "images/word.gif";